"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFormMessageType = void 0;
var CustomFormMessageType;
(function (CustomFormMessageType) {
    /**
     * @deprecated AbortUserTask is deprecated and will be removed in the future. Please use `TerminateProcessInstance` instead.
     */
    CustomFormMessageType["AbortUserTask"] = "abortUserTask";
    CustomFormMessageType["DisplayUserTask"] = "displayUserTask";
    CustomFormMessageType["ErrorOnSetLanguage"] = "errorOnSetLanguage";
    CustomFormMessageType["FinishUserTask"] = "finishUserTask";
    CustomFormMessageType["Initialize"] = "initialize";
    CustomFormMessageType["ResolveDisplayUserTask"] = "resolveDisplayUserTask";
    CustomFormMessageType["ResolveInitialize"] = "resolveInitialize";
    CustomFormMessageType["ResolveSetLanguage"] = "resolveSetLanguage";
    CustomFormMessageType["SuspendUserTask"] = "suspendUserTask";
    CustomFormMessageType["TerminateProcessInstance"] = "terminateProcessInstance";
    CustomFormMessageType["UpdateIdentity"] = "updateIdentity";
    CustomFormMessageType["UpdateLanguage"] = "updateLanguage";
    CustomFormMessageType["TranscendentError"] = "TranscendentError";
})(CustomFormMessageType = exports.CustomFormMessageType || (exports.CustomFormMessageType = {}));
